import React, {Component} from 'react';
import '../react-router-modal/react-router-modal.css';
import '../css/components/alert.css';

interface ConfirmDialogBlockProps {
    title?: string;
    showAlert: boolean;
    onClose: () => void;
    proceedEventHandler: () => void;
    children?: React.ReactNode;
}

interface ConfirmDialogBlockState {
    title: string | false;
    showAlert: boolean;
}

class ConfirmDialogBlock extends Component<ConfirmDialogBlockProps, ConfirmDialogBlockState> {
    constructor(props: ConfirmDialogBlockProps) {
        super(props);

        this.state = {
            title: false,
            showAlert: false
        }
    }

    UNSAFE_componentWillMount() {
        this.setState({
            title: this.props.title ? this.props.title : false,
            showAlert: this.props.showAlert
        })
    }

    UNSAFE_componentWillReceiveProps(newProps: ConfirmDialogBlockProps) {
        if (newProps.showAlert) {
            this.setState({showAlert: newProps.showAlert});
            this.setState({title: newProps.title ? newProps.title : false});
        }
    }

    acceptMyAlert = (): void => {
        this.setState({showAlert: false});
        this.props.onClose();
        this.props.proceedEventHandler();
    };

    closeMyAlert = (): void => {
        this.setState({showAlert: false});
        this.props.onClose();
    };

    render() {
        return (

            <div>
                {this.state.showAlert ?
                    <div className="dialog-block app-modal">
                        <div className="modal-content">
                            <div className={this.state.title ? 'modal-header d-flex' : 'hidden'}>
                                <h3 className="modal-title">{this.state.title}</h3>
                                <button type="button" className="close"
                                        aria-label="Close"
                                        onClick={this.closeMyAlert}>
                                    <img alt="" width="20"
                                         src="../app-images/close.png"/>
                                </button>
                            </div>
                            <div className="modal-body">
                                {this.props.children}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="ss-button-primary-modal-form pull-left"
                                        onClick={this.acceptMyAlert}>Yes
                                </button>
                                <button type="button" className="ss-button-primary-modal-form reverse pull-right"
                                        onClick={this.closeMyAlert}>No
                                </button>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        )
    }
}

export default ConfirmDialogBlock;

